import template from './AttendantsContainerView.html';
import { AttendantsContainerController } from './AttendantsContainerController';
export const AttendantsContainerComponent = {
    require: {
        ngModel: '?ngModel',
    },
    controller: AttendantsContainerController,
    controllerAs: '$ctrl',
    template: template,
    bindings: {
        data: '<',
        application: '<',
        queue: '<',
        onChange: '&?',
    },
};
